import axios from "axios";

const local = 'http://localhost:8080'
const qural = 'https://api.qural.org'
const isLocal = false  // Алина, меняй на true для локальной разработки
const BASE_URL = isLocal ? local : qural;

export default class Service{
    static async pushLogin(login, password){
        const url = `${BASE_URL}/auth/login`;
        const data = {
            login: login,/*  */
            password: password
        };

        try {
            const response = await axios.post(url, data);
            console.log("Response:", response.data);
            if (response.data) {
                localStorage.setItem("token", response.data.token);
            }
            return response;
        } catch (error) {
            console.error("Error:", error);
            return error.response || { status: 500, data: { message: "Unknown error" } };
        }
    }

    static async pushLogout() {
        const url = `${BASE_URL}/auth/logout`;

        try {
            const response = await axios.post(url, {}, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`
                }
            });
            localStorage.removeItem("token");
            return response;
        } catch (error) {
            console.error("Logout Error:", error);
            return error.response || { status: 500, data: { message: "Unknown error" } };
        } finally {
            localStorage.removeItem("token");
        }
    }

    static async getTables(name, searchText=''){
        const url = BASE_URL;
        const token = localStorage.getItem("token");
        const auth = `Bearer ${token}`

        try {
            const response = await axios.get(`${url}/api/${name}?searchText=${searchText}`, {
                headers: {
                    Authorization: auth
                }
            });
            console.log("Response:", response.data);
            return response;
        } catch (error){
            console.error("Error:", error);
            return error.response;
        }
    }

    static async updateData(id, updatedData, name) {
        const url = `${BASE_URL}/api/${name}/${id}`;
        const token = localStorage.getItem("token");
        const auth = `Bearer ${token}`;

        try {
            const response = await axios.put(url, updatedData, {
                headers: {
                    Authorization: auth,
                    "Content-Type": "application/json"
                }
            });
            console.log("Update Response:", response.data);
            return response;
        } catch (error) {
            console.error("Update Error:", error);
            return error.response || { status: 500, data: { message: "Unknown error" } };
        }
    }

    static async getById(id, name){
        const url = `${BASE_URL}/api/${name}/${id}`
        const token = localStorage.getItem("token");
        const auth = `Bearer ${token}`;

        try{
            const response = await axios.get(url, {
                headers: {
                    Authorization: auth
                }
            })
            console.log("Response:", response.data);
            return response;
        } catch (error){
            console.error("Error:", error);
            return error.response;
        }
    }

    static async createDep(data, entity){
        const url = `${BASE_URL}/api/${entity}`
        const token = localStorage.getItem("token");
        const auth = `Bearer ${token}`;

        try {
            const response = await axios.post(url, data, {
                headers: {
                    Authorization: auth
                }
            })
            return response.data;
        }catch (error) {
            console.error("Ошибка при создании:", error);
            throw error;
        }
    }

    static async deleteItem(name, id) {
        const url = `${BASE_URL}/api/${name}/${id}`;
        const token = localStorage.getItem("token");
        const auth = `Bearer ${token}`;

        try {
            const response = await axios.delete(url, {
                headers: {
                    Authorization: auth
                }
            });
            console.log("Delete Response:", response.data);
            return response;
        } catch (error) {
            console.error("Delete Error:", error);
            return error.response || { status: 500, data: { message: "Unknown error" } };
        }
    }

    static async getPersonalData() {
        const url = `${BASE_URL}/api/personal`;
        const token = localStorage.getItem("token");
        const auth = `Bearer ${token}`;
    
        try {
            const response = await axios.get(url, {
                headers: {
                    Authorization: auth,
                },
            });
            return response.data;
        } catch (error) {
            console.error("Error fetching personal data:", error);
            return error.response || { status: 500, data: { message: "Unknown error" } };
        }
    }
    
    static async updatePersonalData(updatedData) {
        const url = `${BASE_URL}/api/personal`;
        const token = localStorage.getItem("token");
        const auth = `Bearer ${token}`;
    
        try {
            const response = await axios.put(url, updatedData, {
                headers: {
                    Authorization: auth,
                    "Content-Type": "application/json",
                },
            });
            return response.data;
        } catch (error) {
            console.error("Error updating personal data:", error);
            return error.response || { status: 500, data: { message: "Unknown error" } };
        }
    }

    //to change password 

    static async sendOtp(email) {
        const url = `${BASE_URL}/otp/init?email=${(email)}`;
        const token = localStorage.getItem("token");
        const auth = `Bearer ${token}`;

        try {
            return await axios.post(url, {
                headers: { Authorization: auth },
            });
        } catch (error) {
            console.error("Error sending OTP:", error);
            throw error;
        }
    }

    static async checkOtp(email, code) {
        const url = `${BASE_URL}/otp/check`;
        const token = localStorage.getItem("token");
        const auth = `Bearer ${token}`;

        try {
            return await axios.post(url, { email, code }, {
                headers: { Authorization: auth },
            });
        } catch (error) {
            console.error("Invalid OTP:", error);
            throw error;
        }
    }

    static async changePassword(email, newPassword) {
        const url = `${BASE_URL}/api/personal/password`;
        const token = localStorage.getItem("token");
        const auth = `Bearer ${token}`;

        try {
            return await axios.put(url, { login: email, password: newPassword }, {
                headers: { Authorization: auth },
            });
        } catch (error) {
            console.error("Error changing password:", error);
            throw error;
        }
    }

    // notifications 

    static async getUnreadNotifications() {
        const url = "https://api.qural.org/api/notifications/unread";
        const token = localStorage.getItem("token");
        const auth = `Bearer ${token}`;
    
        try {
            const response = await axios.get(url, {
                headers: { Authorization: auth },
            });
    
            return response.data;
        } catch (error) {
            console.error("Error fetching notifications:", error);
            return [];
        }
    }

    static async markAllNotificationsAsRead() {
        const url = `${BASE_URL}/api/notifications`;
        const token = localStorage.getItem("token");
        const auth = `Bearer ${token}`;

        try {
            const response = await axios.put(url, {}, {
                headers: { Authorization: auth }
            });
            console.log("Mark all notifications as read:", response.data);
            return response;
        } catch (error) {
            console.error("Error marking all notifications as read:", error);
            return error.response || { status: 500, data: { message: "Unknown error" } };
        }
    }

    static async markNotificationAsRead(notificationId) {
        const url = `${BASE_URL}/api/notifications/${notificationId}`;
        const token = localStorage.getItem("token");
        const auth = `Bearer ${token}`;

        try {
            const response = await axios.put(url, {}, {
                headers: { Authorization: auth }
            });
            console.log(`Notification ${notificationId} marked as read:`, response.data);
            return response;
        } catch (error) {
            console.error(`Error marking notification ${notificationId} as read:`, error);
            return error.response || { status: 500, data: { message: "Unknown error" } };
        }
    }

    static async getUsers(name, filter={}, page = 1, size = 5){
        const url = BASE_URL;
        const token = localStorage.getItem("token");
        const auth = `Bearer ${token}`
        console.log("Applied filters:",filter)
        try {
            const response = await axios.get(`${url}/api/${name}?isBlocked=${filter.isBlocked}&searchText=${filter.searchText}&departmentId=${filter.departmentId}&courseYear=${filter.courseYear}&page=${page-1}&size=${size}`, {
                headers: {
                    Authorization: auth
                }
            });
            console.log("Response:", response.data);
            return response;
        } catch (error){
            console.error("Error:", error);
            return error.response;
        }
    }

    static async getCourses(name, filters = {}){
        const url = BASE_URL;
        const token = localStorage.getItem("token");
        const auth = `Bearer ${token}`
        console.log("Applied filters:")
        try {
            const response = await axios.get(`${url}/api/${name}?searchText=${filters.searchText}&departmentId=${filters.departmentId}&teacherId=${filters.teacherId}&status=${filters.status}&startDate=${filters.startDate}&endDate=${filters.endDate}`, {
                headers: {
                    Authorization: auth
                }
            });
            console.log("Response:", response.data);
            return response;
        } catch (error){
            console.error("Error:", error);
            return error.response;
        }
    }

    static async uploadUsers(entity, file) {
        const url = BASE_URL;
        const token = localStorage.getItem("token");

        const formData = new FormData();
        formData.append("file", file);

        console.log("Uploading file:", file);
        console.log("FormData:", [...formData.entries()]);

        try {
            const response = await axios.post(`${url}/api/${entity}/upload`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                },
                responseType: "blob", // Ожидаем бинарные данные (файл)
            });

            const contentType = response.headers["content-type"];
            if (contentType.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")) {
                console.log("Received a file response. Initiating download...");
                return this.downloadFile(response);
            }

            console.log("Response:", response.data);
            return response.data;
        } catch (error) {
            console.error("Error:", error);

            if (error.response && error.response.data) {
                return this.downloadFile(error.response);
            }

            return error.response;
        }
    }

    static downloadFile(response) {
        const blob = new Blob([response.data], { type: response.headers["content-type"] });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;

        const contentDisposition = response.headers["content-disposition"];
        let filename = "download.xlsx"; // Имя по умолчанию

        if (contentDisposition) {
            const match = contentDisposition.match(/filename="(.+)"/);
            if (match && match[1]) {
                filename = match[1];
            }
        }

        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
    }

    static async blockUser(entity, id){
        const url = BASE_URL;
        const token = localStorage.getItem("token");
        const auth = `Bearer ${token}`;

        try {
            const response = await axios.put(`${url}/api/${entity}/block/${id}`, id, {
                headers: {
                    Authorization: auth,
                    "Content-Type": "application/json"
                },
            });
            console.log("Response:", response.data);
            return response;
        } catch (error) {
            console.error("Error:", error);
            return error.response;
        }
    }

    static async unblockUser(entity, id){
        const url = BASE_URL;
        const token = localStorage.getItem("token");
        const auth = `Bearer ${token}`;

        try {
            const response = await axios.put(`${url}/api/${entity}/unblock/${id}`, id, {
                headers: {
                    Authorization: auth,
                    "Content-Type": "application/json"
                },
            });
            console.log("Response:", response.data);
            return response;
        } catch (error) {
            console.error("Error:", error);
            return error.response;
        }
    }

    static async downloadTemplate() {
        const url = `${BASE_URL}/api/students/get-template`;
        const token = localStorage.getItem("token");
        const auth = `Bearer ${token}`;

        try {
            const response = await axios.get(url, {
                headers: { Authorization: auth },
                responseType: "blob",
            });

            const blob = new Blob([response.data]);
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.setAttribute("download", "students_template.xlsx"); // Название файла
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error("Error downloading file:", error);
        }
    }

    static async getTeachersByDepId(depId){
        const url = BASE_URL;
        const token = localStorage.getItem("token");
        const auth = `Bearer ${token}`

        try {
            const response = await axios.get(`${url}/api/teachers?departmentId=${depId}`, {
                headers: {
                    Authorization: auth
                }
            });
            console.log("Response:", response.data);
            return response;
        } catch (error){
            console.error("Error:", error);
            return error.response;
        }
    }

    static async activateCourse(id){
        const url = BASE_URL;
        const token = localStorage.getItem("token");
        const auth = `Bearer ${token}`

        try {
            const response = await axios.put(`${url}/api/courses/active/${id}`, id, {
                headers: {
                    Authorization: auth
                }
            });
            console.log("Response:", response.data);
            return response;
        } catch (error){
            console.error("Error:", error);
            return error.response;
        }
    }

    static async deActivateCourse(id){
        const url = BASE_URL;
        const token = localStorage.getItem("token");
        const auth = `Bearer ${token}`

        try {
            const response = await axios.put(`${url}/api/courses/archive/${id}`, id, {
                headers: {
                    Authorization: auth
                }
            });
            console.log("Response:", response.data);
            return response;
        } catch (error){
            console.error("Error:", error);
            return error.response;
        }
    }
}
